export default __webpack_public_path__ + "static/media/locationnew.c514c0a2.svg";